import React, { createContext, useContext, useState } from "react";

interface NodeDataContextType {
	eventBasedState: boolean;
	setEventBasedState: (value: boolean) => void;
}

const NodeDataContext = createContext<NodeDataContextType | undefined>(undefined);

export const useGlobalNodesData = () => {
	const context = useContext(NodeDataContext);

	if (!context) {
		throw new Error("useGlobalNodesData must be used within GlobalNodesDataProvider");
	}

	return context;
};

export const GlobalNodesDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [eventBasedState, setEventBasedState] = useState<boolean>(false); // Default value

	return (
		<NodeDataContext.Provider value={{ eventBasedState, setEventBasedState }}>
			{children}
		</NodeDataContext.Provider>
	);
};
